exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2A3EkH1V_UyDTP{display:flex}._3Yj9q2I4BGFx4r ._1uWLDFWlmhvDog{width:0;height:18px;opacity:0;transition-duration:.15s;transition-property:opacity,width,margin}._3Yj9q2I4BGFx4r:hover ._1uWLDFWlmhvDog{opacity:.75;width:18px;margin-right:6px}", ""]);

// exports
exports.locals = {
	"sectionHeaderWrapper": "_2A3EkH1V_UyDTP",
	"externalLink": "_3Yj9q2I4BGFx4r",
	"externalIcon": "_1uWLDFWlmhvDog"
};